import dragscroll from 'dragscroll';

$('.js-bar').each(function (index, el) {
  new SimpleBar(el);
});

$('.simplebar-content-wrapper').addClass('dragscroll');
dragscroll.reset();
